'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.tabbedSectionWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this,
			defaultTabName = widget.find('[data-mm-tab-default]').attr('data-mm-tab'),
			selectTab = function (tabName) {
				widget.find('tabbedsectiontitle').removeClass('active');
				widget.find('tabbedsectiontitle[data-mm-tab=' + tabName + ']').addClass('active');

				widget.find('tabbedSectioncontent').addClass('hidden');
				widget.find('tabbedSectioncontent[data-mm-tab=' + tabName + ']').removeClass('hidden');

			},
			reset = function () {
				selectTab(defaultTabName);
			};
		reset();
		widget.find('tabbedsectiontitle').on('click focus', (e) => {
			const tabName = e.currentTarget && e.currentTarget.getAttribute('data-mm-tab');
			selectTab(tabName);
		});
		widget.on('reset', reset);
		widget.on('resetdefaulttab', () => {
			const defaultOnShow = widget.attr('data-mm-tab-section-show');
			if (defaultOnShow && defaultTabName) {
				selectTab(defaultTabName);
			}
		});
	});
};
